import {Inject, Injectable} from "ng-metadata/core";
import {PrimoResponse} from "../../../infra/dataStructures/PrimoResponses/doc.interfcae";
import {PermalinkService} from "../permalinkAction/permalink.service";

@Injectable()
export class EmailClientService {
    constructor(@Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$q') private $q: ng.IQService,
                private permaLinkService: PermalinkService) {}

    public emailAction(item: PrimoResponse.IDoc): void {
        this.generateEmailContent(item).then(content => window.open(content, '_blank'));
    }

    private buildEmailSubject(): angular.IPromise<string> {
        return this.$translate('email.itemsfound');
    }

    private buildEmailBody(record: PrimoResponse.IDoc): angular.IPromise<string> {
        return this.getPermaLinkFor(record).then(permaLink =>
            `${record.pnx.display['title'] || ''}\n${permaLink}`
        )
    }

    private getPermaLinkFor(record): angular.IPromise<string> {
        return this.permaLinkService.getPermalink(record, undefined)
            .then(permaLink => permaLink.data.shortPermalink)
    }

    private generateEmailContent(item: PrimoResponse.IDoc): angular.IPromise<string> {
        return this.$q.all([this.buildEmailSubject(), this.buildEmailBody(item)]).then(([subject, body]) =>
            `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`);
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/sendEmailAction/emailClient.service.ts